import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4905aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox-container" }
const _hoisted_2 = { class: "checkbox" }
const _hoisted_3 = { for: "PublishingRoyaltiesTerms" }
const _hoisted_4 = ["href", "textContent"]
const _hoisted_5 = { class: "dialog-actions" }
const _hoisted_6 = ["disabled"]

import { ref } from 'vue'
import { useGettext } from 'vue3-gettext'
import DialogUI from '@/components/CommonUI/DialogUI.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkRoyaltiesTermsDialog',
  emits: ["confirm"],
  setup(__props, { expose: __expose, emit }) {

const { $gettext, current } = useGettext()
const dialog = ref<IDialogUI>()
const isConfirmed = ref(false)
const termsLink = ref(`https://dittomusic.com/${current}/publishing-plus-terms`)


function show() {
  dialog.value?.show()
}
function hide() {
  dialog.value?.hide()
}

function confirm() {
  emit('confirm')
  hide()
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(DialogUI, {
    ref_key: "dialog",
    ref: dialog,
    size: "small",
    "data-testid": "royalties-terms-dialog",
    title: _unref($gettext)('Collect publishing royalties for this Musical Work')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            id: "PublishingRoyaltiesTerms",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isConfirmed).value = $event)),
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, isConfirmed.value]
          ]),
          _createElementVNode("label", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_unref($gettext)('I accept Ditto Music')), 1),
            _createElementVNode("a", {
              href: termsLink.value,
              target: "_blank",
              rel: "noopener noreferrer",
              textContent: _toDisplayString(_unref($gettext)('Publishing writer terms and conditions'))
            }, null, 8, _hoisted_4)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "secondary full-width",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (hide()))
        }, [
          _createTextVNode(" Cancel ")
        ])), [
          [_directive_translate]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "full-width",
          disabled: !isConfirmed.value,
          onClick: confirm
        }, [
          _createTextVNode(" Confirm ")
        ], 8, _hoisted_6)), [
          [_directive_translate]
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})